<template>
  <div class="animated fadeIn">
    <default-heading text="Add Field" class="mt-3" />

    <div>
      <b-card class="mt-3">
        <b-form @submit.prevent="saveField">
          <CustomerFieldFormGroup
            :vuelidate="$v.customer_field"
            @onChange="onChange"
          />
        </b-form>
      </b-card>

      <b-alert show v-if="error" variant="danger">{{ error }}</b-alert>

      <div class="clearfix mb-5">
        <b-button variant="success" class="float-right" :disabled="submittingForm" @click="saveField">
          <i v-if="submittingForm" class="fal fa-spinner fa-spin"></i>
          <span v-else>Save</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import CustomerFieldFormGroup from '@/components/crm/customer/CustomerFieldFormGroup'
import { validationMixin } from 'vuelidate/src'
import { required } from 'vuelidate/lib/validators'
import CustomerFieldModel from '@/models/crm/CustomerFieldModel'

export default {
  name: 'CustomerFieldAdd',
  components: {
    DefaultHeading,
    CustomerFieldFormGroup
  },
  mixins: [validationMixin],
  data () {
    return {
      customer_field: new CustomerFieldModel(),
      customer_grower_id: this.$route.params.id || null,
      error: null,
      submittingForm: false
    }
  },
  validations: {
    customer_field: {
      name: { required }
    }
  },
  methods: {
    onChange (customer_field) {
      this.customer_field.set(customer_field)
    },

    saveField () {
      this.error = null
      this.submittingForm = true
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.submittingForm = false
        return
      }

      this.customer_field.set('customer_id', this.$store.getters.getAuthCustomerID)
      this.customer_field.set('customer_grower_id', this.customer_grower_id)

      this.customer_field.save().then(() => {
        this.$bvToast.toast('', {
          title: 'Field created successfully',
          variant: 'success',
          autoHideDelay: 1000
        })

        this.submittingForm = false
        this.$router.push('/customer-growers/' + this.customer_grower_id)
      }).catch((err) => {
        this.submittingForm = false

        if (err.response && err.response.response && err.response.response.data && err.response.response.data.message) {
          this.error = err.response.response.data.message
          return
        }

        this.error = err.err || 'Something went wrong please contact an administrator'
      })
    }
  }
}
</script>
